<template>
  <div class="btn-group">
    <div
        @click="prevPage()"
        v-if="!firstPageSelected()"
        class="btn"
    >
      Назад
    </div>
    <template v-for="page in pages">
      <div
          :key="page.index"
          class="btn"
          v-if="page.breakView"
          :class="['', page.disabled ? disabledClass : '']"
      >
        <slot name="breakViewContent">
          ...
        </slot>
      </div>
      <div
          :key="page.index"
          class="btn"
          v-else-if="page.disabled"
          :class="[
                    '',
                    page.selected ? activeClass : '',
                    disabledClass,
                ]"
      >
        {{ page.content }}
      </div>
      <div
          :key="page.index"
          class="btn"
          :class="page.selected ? activeClass : ''"
          v-else
          @click="handlePageSelected(page.index + 1)"
      >
        {{ page.content }}
      </div>
    </template>
    <div
        @click="nextPage()"
        v-if="!lastPageSelected()"
        class="btn"
    >
      Далее
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    forcePage: {
      type: Number,
    },
    clickHandler: {
      type: Function,
      default: () => {},
    },
    pageRange: {
      type: Number,
      default: 3,
    },
    marginPages: {
      type: Number,
      default: 1,
    },
    activeClass: {
      type: String,
      default: 'active',
    },
    disabledClass: {
      type: String,
      default: 'disabled',
    },
    hidePrevNext: {
      type: Boolean,
      default: false,
    },
  },
  beforeUpdate() {
    if (this.forcePage === undefined) return
    if (this.forcePage !== this.selected) {
      this.selected = this.forcePage
    }
  },
  computed: {
    selected: {
      get: function() {
        return this.value || this.innerValue
      },
      set: function(newValue) {
        this.innerValue = newValue
      },
    },
    pages: function() {
      let items = {}
      if (this.pageCount <= this.pageRange) {
        for (let index = 0; index < this.pageCount; index++) {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected - 1,
          }
          items[index] = page
        }
      } else {
        const halfPageRange = Math.floor(this.pageRange / 2)
        let setPageItem = index => {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected - 1,
          }
          items[index] = page
        }
        let setBreakView = index => {
          let breakView = {
            disabled: true,
            breakView: true,
          }
          items[index] = breakView
        }
        // 1st - loop thru low end of margin pages
        for (let i = 0; i < this.marginPages; i++) {
          setPageItem(i)
        }
        // 2nd - loop thru selected range
        let selectedRangeLow = 0
        if (this.selected - halfPageRange > 0) {
          selectedRangeLow = this.selected - 1 - halfPageRange
        }
        let selectedRangeHigh = selectedRangeLow + this.pageRange - 1
        if (selectedRangeHigh >= this.pageCount) {
          selectedRangeHigh = this.pageCount - 1
          selectedRangeLow = selectedRangeHigh - this.pageRange + 1
        }
        for (
            let i = selectedRangeLow;
            i <= selectedRangeHigh && i <= this.pageCount - 1;
            i++
        ) {
          setPageItem(i)
        }
        // Check if there is breakView in the left of selected range
        if (selectedRangeLow > this.marginPages) {
          setBreakView(selectedRangeLow - 1)
        }
        // Check if there is breakView in the right of selected range
        if (selectedRangeHigh + 1 < this.pageCount - this.marginPages) {
          setBreakView(selectedRangeHigh + 1)
        }
        // 3rd - loop thru high end of margin pages
        for (
            let i = this.pageCount - 1;
            i >= this.pageCount - this.marginPages;
            i--
        ) {
          setPageItem(i)
        }
      }
      return items
    },
  },
  data() {
    return {
      innerValue: 1,
    }
  },
  methods: {
    handlePageSelected(selected) {
      if (this.selected === selected) return
      this.innerValue = selected
      this.$emit('input', selected)
      this.clickHandler(selected)
    },
    prevPage() {
      if (this.selected <= 1) return
      this.handlePageSelected(this.selected - 1)
    },
    nextPage() {
      if (this.selected >= this.pageCount) return
      this.handlePageSelected(this.selected + 1)
    },
    firstPageSelected() {
      return this.selected === 1
    },
    lastPageSelected() {
      return this.selected === this.pageCount || this.pageCount === 0
    },
    // selectFirstPage() {
    //     if (this.selected <= 1) return
    //     this.handlePageSelected(1)
    // },
    // selectLastPage() {
    //     if (this.selected >= this.pageCount) return
    //     this.handlePageSelected(this.pageCount)
    // }
  },
}
</script>

<style lang="scss" scoped>
.btn-group {
  font-size: 0;
  line-height: 1;
  white-space: nowrap;
  display: block;

  & > .btn {
    color: #7A818F;
    background: transparent;
    border: 1px solid #B6BCC8;
    border-left-width: 0;
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    padding: 11px 18px;
    outline: 0;

    &:first-child {
      border-left-width: 1px;
      border-radius: 4px 0 0 4px;
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
    }

    &:hover {
      background-color: rgba(44,177,129,0.05);
      color: #2CB181;
    }

    &.active {
      border: 1px solid #2cb181;
      color: #2CB181;
    }

    &.disabled {
      cursor: unset;
    }
  }
}
</style>
